import React from 'react';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { Select, Popover, Tag } from 'antd';
import { faShareAlt, faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from '@components/IconButton';
import { useTranslation } from 'react-i18next';

export default ({ pathway, currentSnapshot, snapshots }) => {
  const { t } = useTranslation();
  const history = useHistory();

  if (!pathway || !pathway?.id) {
    return null;
  }

  return (
    <div className="pathway-details-title-container">
      <div>{pathway.name.length > 50 ? `${pathway.name.slice(0, 50)}...` : pathway.name}</div>
      {Boolean(snapshots?.length) && pathway && (
        <>
          <div className="pathway-snapshots-dropdown-container">
            <Select
              defaultValue={currentSnapshot?.snapshotNumber?.toString() ?? '0'}
              onChange={snapshot => {
                let path = `/procedure/pathways/${pathway.id}/${snapshot}`;
                if (snapshot === '0') {
                  path = `/procedure/pathways/${pathway.id}`;
                }
                history.push(path);
              }}
              dropdownClassName="pathway-snapshots-dropdown"
              className="pathway-snapshots-dropdown-select"
            >
              <Select.Option key="0" value="0" className="active-snapshot-option">
                {t('pathways:ProcedurePathways.createSnapshot.active')}
              </Select.Option>
              <Select.OptGroup label={t('pathways:ProcedurePathways.createSnapshot.snapshots')}>
                {snapshots.map(snap => (
                  <Select.Option
                    key={snap.snapshotNumber.toString()}
                    value={snap.snapshotNumber.toString()}
                  >
                    <p className="snapshot-name">{snap.snapshotName}</p>
                    <p className="snapshot-creation-date-text">
                      {t('pathways:ProcedurePathways.createSnapshot.creationDate')}{' '}
                      {moment(snap.creation).format('D MMM YY')}
                    </p>
                    {snap.isSharedSnapshot ? (
                      <div className="shared-tag">
                        <Tag color="#ccc">
                          <FontAwesomeIcon icon={faShareAlt} />{' '}
                          {t('pathways:ProcedurePathways.createSnapshot.shared')}
                        </Tag>
                      </div>
                    ) : null}
                  </Select.Option>
                ))}
              </Select.OptGroup>
            </Select>
          </div>
          <div className="pathway-snapshots-popover-container">
            <Popover
              content={
                <>
                  <p>{t('pathways:ProcedurePathways.createSnapshot.explanation1')}</p>
                  <p>{t('pathways:ProcedurePathways.createSnapshot.explanation2')}</p>
                </>
              }
              title={t('pathways:ProcedurePathways.createSnapshot.pathwaySnapshots')}
              trigger="click"
              placement="top"
              overlayClassName="pathway-snapshots-popover"
            >
              <IconButton
                icon={faInfoCircle}
                tooltip={t('common:buttons.info')}
                onClick={() => {}}
              />
            </Popover>
          </div>
        </>
      )}
    </div>
  );
};
